import { usePersistedStore, useEphemeralStore } from '@/lib/app-store';
import { useMatch } from '@tanstack/react-router';
import { useEffect } from 'react';

export function AutoResetDonationFlow() {
	const amount = usePersistedStore((state) => state.amount);
	const setAmount = usePersistedStore((state) => state.setAmount);
	const details = usePersistedStore((state) => state.details);
	const setDetails = usePersistedStore((state) => state.setDetails);
	const setTermsContent = usePersistedStore((state) => state.setTermsContent);
	const setNgosTermsContent = usePersistedStore((state) => state.setNgosTermsContent);
	const setTelefonicaTermsContent = usePersistedStore((state) => state.setTelefonicaTermsContent);
	const clearCheckoutCache = useEphemeralStore((state) => state.clearCheckoutCache);
	const donateRouteMatch = useMatch({ from: '/$portalId/$campaignId/donate', shouldThrow: false });
	const donateThanksRouteMatch = useMatch({ from: '/$portalId/$campaignId/donate/thanks', shouldThrow: false });
	const isDonating = donateRouteMatch && !donateThanksRouteMatch;

	useEffect(() => {
		if (
			!isDonating &&
			(amount != null ||
				details.termsAndConditions ||
				details.ngosTermsAndConditions ||
				details.telefonicaTermsAndConditions)
		) {
			setAmount(undefined);
			setDetails({
				...details,
				termsAndConditions: false,
				ngosTermsAndConditions: false,
				telefonicaTermsAndConditions: false,
			});
			setTermsContent(undefined);
			setNgosTermsContent(undefined);
			setTelefonicaTermsContent(undefined);
			clearCheckoutCache();
		}
	}, [
		amount,
		details,
		isDonating,
		setAmount,
		setDetails,
		setNgosTermsContent,
		setTelefonicaTermsContent,
		setTermsContent,
		clearCheckoutCache,
	]);

	return null;
}
